const availableFonts = [
    { name: "Alexa", style: "font-family: 'Alexa';" },
    { name: "Northshore", style: "font-family: 'Northshore';" },
    { name: "WildScript", style: "font-family: 'WildScript';" },
    { name: "LoveNote", style: "font-family: 'LoveNote';" },
    { name: "Signature", style: "font-family: 'Signature';" },
    { name: "LoveNeon", style: "font-family: 'LoveNeon';" },
    { name: "Melbourne", style: "font-family: 'Melbourne';" },
    { name: "Greenworld", style: "font-family: 'Greenworld';" },
    { name: "Bayview", style: "font-family: 'Bayview';" },
    { name: "NewCursive", style: "font-family: 'NewCursive';" },
    { name: "Typewriter", style: "font-family: 'Typewriter';" },
    { name: "NeoTokyo", style: "font-family: 'NeoTokyo';" },
    { name: "Marquee", style: "font-family: 'Marquee';" },
    { name: "Buttercup", style: "font-family: 'Buttercup';" },
    { name: "Chelsea", style: "font-family: 'Chelsea';" },
    { name: "ClassicType", style: "font-family: 'ClassicType';" },
    { name: "Roboto-Regular", style: "font-family: 'Roboto-Regular';" },
    { name: "Royalty", style: "font-family: 'Royalty';" },
    { name: "Roboto-Medium", style: "font-family: 'Roboto-Medium';" },
    { name: "Beachfront", style: "font-family: 'Beachfront';" },
    { name: "Austin", style: "font-family: 'Austin';" },
    { name: "Neontrace", style: "font-family: 'Neontrace';" },
    { name: "Amsterdam", style: "font-family: 'Amsterdam';" },
    { name: "Vintage", style: "font-family: 'Vintage';" },
    { name: "Freehand", style: "font-family: 'Freehand';" },
    { name: "Neonscript", style: "font-family: 'Neonscript';" },
    { name: "Freespirit", style: "font-family: 'Freespirit';" },
    { name: "NeonLite", style: "font-family: 'NeonLite';" },
    { name: "Avante", style: "font-family: 'Avante';" },
    { name: "Rocket", style: "font-family: 'Rocket';" },
    { name: "NeonGlow", style: "font-family: 'NeonGlow';" },
    { name: "Amanda", style: "font-family: 'Amanda';" },
    { name: "Monaco", style: "font-family: 'Monaco';" },
    { name: "Barcelona", style: "font-family: 'Barcelona';" },
    { name: "Bauhaus", style: "font-family: 'Bauhaus';" },
    { name: "Outline", style: "font-family: 'Outline';" },
    { name: "Waikiki", style: "font-family: 'Waikiki';" },
    { name: "SciFi", style: "font-family: 'SciFi';" },
  ];

  var inchFactor = 8;
  var neonObject = {
    previewText: "Smash Here",
    alignmentType: "center",
    backgroundImage: 2,
    font: "Alexa",
    color: {
      name: "Warm White",
      value: "#fff2b9",
    },
    fontSize: 7 * inchFactor,
    backboardType: "Shape",
    shipping: 0
  }
  var newPrice = "";
  var adjustedFontSize = 0;
  var finalFontSize = 0;
  var sizeOption = 'small';
  //input functions start
  function handleInputChange(value, name, style) {
    neonObject[name] = value;
    if (style) {
      updateInputStyle(`.${name}`, style);
    }
    if (name === 'fontSize') {
      setCustomSize(false, style);
    }
    updatePreview();
  }

  function updateInputStyle(value, element) {
    if (value !== '.backgroundImage') {
      document.querySelectorAll(value).forEach((option) => {
        option.classList.remove(
          "outline-customBlue",
          "outline-2"
        );
        option.classList.add(
          "outline-1");
      });

      element.classList.add(
        "outline-customBlue",
        "outline-2"
      );
      if (value === '.color') {
        document.querySelectorAll(value).forEach((option) => {
          option.classList.remove(
            "outline"
          );
        });

        element.classList.add(
          "outline"
        );
      }
    }
    else {
      document.querySelectorAll(value).forEach((option) => {
        option.classList.remove(
          "border-customBlue",
        );
        option.classList.add(
          "border-white",
          "opacity-60"
        );
      });

      element.classList.add(
        "border-customBlue",
      );
      element.classList.remove(
        "border-white",
        "opacity-60"
      );
    }

  }

  function setCustomSize(value, element) {
    const customSlider = document.getElementById("custom-slider");
    let option = element.querySelector('b') ? element.querySelector('b').textContent.toLowerCase() : null;
    if (option) {
      sizeOption = option;
    } else {
      sizeOption = 'custom';
    }

    updateInputStyle(".fontSize", element);
    if (value) {
      customSlider.classList.remove("hidden");
      const sliderValue = document.getElementById("custom-size-slider").value * inchFactor;
      changeFontSize(sliderValue);
    } else {
      customSlider.classList.add("hidden");
    }
  }

  function changeFontSize(value) {
    neonObject.fontSize = value;
    updatePreview();
  }
  //input functions end

  //preview functions start
  function updatePreview() {
    var preview = document.getElementById("custom-text-preview");
    var styleElement = document.getElementById("customStyle");
    var previewbox = document.getElementById("previewbox");
    var previewRectangle = document.getElementById("custom-text-rectangle");

    previewbox.style.justifyContent = neonObject.alignmentType;
    previewbox.style.alignItems = "center";
    var fontAndSize = neonObject.fontSize + "px " + neonObject.font;
    var dimension = getTextDimensions(neonObject.previewText, fontAndSize);

    var viewportWidth = window.innerWidth;
    var maxWidth = (30 / 100) * viewportWidth;
    if (dimension.width > maxWidth) {
      adjustedFontSize = Math.floor((maxWidth / dimension.width) * neonObject.fontSize);
      finalFontSize = adjustedFontSize;
    } else {
      finalFontSize = neonObject.fontSize;
    }

    preview.textContent = neonObject.previewText;
    preview.style.fontFamily = neonObject.font;
    preview.textContent = neonObject.previewText;
    preview.style.fontSize = finalFontSize + "px";

    if (neonObject.color.name === "RGB") {
      preview.style.backgroundImage =
        "linear-gradient(270deg, red, orange, yellow, green, blue, indigo, violet)";
      preview.style.backgroundPosition = "right";
      preview.style.backgroundClip = "text";
      preview.style.webkitBackgroundClip = "text";
      styleElement.innerHTML = `
            @keyframes rainbow {
                0% { background-position: 100%; }
                100% { background-position: 0%; }
            }
            #custom-text-preview {
              animation: rainbow 3s linear infinite;
              -webkit-background-clip: text;
              color: transparent; 
              background-size: 500%;
              font-size: ${finalFontSize + "px"};
              content: "${neonObject.previewText}";
              max-width: 30vw;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              position: relative;
            }
            `;
      preview.style.textShadow = "";
      document.head.appendChild(styleElement);
    } else {
      preview.style.backgroundImage = "none";
      styleElement.innerHTML = `
        #custom-text-preview{
          font-size: ${finalFontSize + "px"};
          color: white;
          content: "${neonObject.previewText}";
          max-width: 30vw;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
          position: relative;
          text-shadow: 0 0 2px ${neonObject.color.value},
        0 0 10px ${neonObject.color.value}, 
        0 0 15px ${neonObject.color.value}, 
        0 0 20px ${neonObject.color.value}, 
        0 0 35px ${neonObject.color.value},
        0 0 40px ${neonObject.color.value},
        0 0 155px ${neonObject.color.value};
        }
      `;
    }

    if (neonObject.backboardType === "Letter") {
      styleElement.innerHTML = styleElement.innerHTML +
        `
         #custom-text-preview::before {
            font-size: ${finalFontSize + "px"};
            content: "${neonObject.previewText}";
            max-width: 30vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            color: transparent;
            -webkit-text-stroke: ${finalFontSize / 7 - 3}px white;
            text-shadow: none;
        }

        #custom-text-preview::after {
            font-size: ${finalFontSize + "px"};
            content: "${neonObject.previewText}";
            max-width: 30vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -2;
            text-shadow: none;
            -webkit-text-stroke: ${finalFontSize / 7}px black;
        }
        `
      previewRectangle.style.cssText = "";
    }
    else if (neonObject.backboardType === "Shape") {
      styleElement.innerHTML = styleElement.innerHTML +
        `
         #custom-text-preview::before {
            font-size: ${finalFontSize + "px"};
            content: "${neonObject.previewText}";
            max-width: 30vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            -webkit-text-stroke: ${finalFontSize / 4 - 3}px white;
            text-shadow: none;
        }

        #custom-text-preview::after {
            font-size: ${finalFontSize + "px"};
            content: "${neonObject.previewText}";
            max-width: 30vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -2;
            -webkit-text-stroke: ${finalFontSize / 4}px black;
            text-shadow: none;
        }
        `
      previewRectangle.style.cssText = "";
    }
    else {
      var fontAndSize = finalFontSize + "px " + neonObject.font;
      var finaldimension = getTextDimensions(neonObject.previewText, fontAndSize);
      previewRectangle.style.border = `1px solid black`;
      previewRectangle.style.backgroundColor = `rgba(255, 255, 255, 0.5)`;
      previewRectangle.style.paddingLeft = `${finaldimension.width / 10}px`;
      previewRectangle.style.paddingRight = `${finaldimension.width / 10}px`;

       if (neonObject.font == "Northshore") {
        preview.style.marginBottom = "-10px";
        preview.style.marginTop = "10px";
      }else if (neonObject.font == "Freespirit") {
        preview.style.marginTop = "25px";
      }else if (neonObject.font == "Barcelona") {
        preview.style.marginTop = "20px";
        preview.style.marginBottom = "20px";
      }
      else if (neonObject.font == "Rocket") {
        preview.style.marginTop = "20px";
        preview.style.marginBottom = "20px";
      }
      else {
        preview.style.marginBottom = "0px";
        preview.style.marginTop = "0px";
      }
    }

    document.head.appendChild(styleElement);
    changeBackground();
    updatedimensions(dimension);
  }

  function changeBackground() {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    const previewSection = document.getElementById("previewSection");
    const parentContainer = document.getElementById("parentContainer");

    if (mediaQuery.matches) {
      inchFactor = 8;
      previewSection.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0887/4931/0318/files/BG-${neonObject.backgroundImage}.jpg')`;
      previewSection.style.backgroundSize = "cover";
      previewSection.style.backgroundPosition = "center";
      previewSection.style.backgroundRepeat = "no-repeat";

      parentContainer.style.backgroundImage = "";
    } else {
      inchFactor = 5;
      parentContainer.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0887/4931/0318/files/BG-${neonObject.backgroundImage}.jpg')`;
      parentContainer.style.backgroundSize = "cover";
      parentContainer.style.backgroundPosition = "center";
      parentContainer.style.backgroundRepeat = "no-repeat";

      previewSection.style.backgroundImage = "";
    }
  }

  function updatedimensions(dimension) {
    var fontAndSize = finalFontSize + "px " + neonObject.font;
    var finaldimension = getTextDimensions(neonObject.previewText, fontAndSize);
    var dimensionHorizontalSize = document.getElementById("dimensionHorizontalSize");
    var dimensionVerticalSize = document.getElementById("dimensionVerticalSize");

    dimensionVerticalSize.style.height = finaldimension.height + "px";
    dimensionHorizontalSize.style.width = finaldimension.width + "px";


    var heightInch = parseFloat((dimension.height / inchFactor).toFixed(2));
    var widthInch = parseFloat((dimension.width / inchFactor).toFixed(2));

    validateWidth(widthInch);
    updatePrice(heightInch, widthInch);

    var heightCM = parseFloat((heightInch * 2.54).toFixed(2));
    var widthCM = parseFloat((widthInch * 2.54).toFixed(2));
    if (widthInch == 0 || heightInch == 0) {
      document.getElementById(
        "size-display"
      ).textContent = `0cm x 0cm / 0in x 0in`;
    } else {
      switch (sizeOption) {
        case 'small':
          document.getElementById("dimensionHorizontalDisplay").textContent = `37.14in / 94.32cm`;
          document.getElementById("dimensionVerticalDisplayIN").textContent = `7in`;
          document.getElementById("dimensionVerticalDisplayCM").textContent = `17.77cm`;
          document.getElementById(
            "size-display"
          ).textContent = `94.32cm x 17.77cm / 37.14in x 7in`;
          break;
        case 'medium':
          document.getElementById("dimensionHorizontalDisplay").textContent = `51.99in /132.05cm`;
          document.getElementById("dimensionVerticalDisplayIN").textContent = `9.80in`;
          document.getElementById("dimensionVerticalDisplayCM").textContent = `24.88cm`;
          document.getElementById(
            "size-display"
          ).textContent = `132.05cm x 24.88cm / 51.99in x 9.80in`;
          break;
        case 'large':
          document.getElementById("dimensionHorizontalDisplay").textContent = `63.13in / 160.35cm`;
          document.getElementById("dimensionVerticalDisplayIN").textContent = `11.90in`;
          document.getElementById("dimensionVerticalDisplayCM").textContent = `30.21cm`;
          document.getElementById(
            "size-display"
          ).textContent = `160.35cm x 30.21cm / 63.13in x 11.90in`;
          break;
        case 'extra large':
          document.getElementById("dimensionHorizontalDisplay").textContent = `74.25in / 188.65cm`;
          document.getElementById("dimensionVerticalDisplayIN").textContent = `13.99in`;
          document.getElementById("dimensionVerticalDisplayCM").textContent = `35.55cm`;
          document.getElementById(
            "size-display"
          ).textContent = `188.65cm x 35.55cm / 74.25in x 13.99in`;
          break;
        default:
          document.getElementById("dimensionHorizontalDisplay").textContent = `${widthInch}in / ${widthCM}cm`;
          document.getElementById("dimensionVerticalDisplayIN").textContent = `${heightInch}in`;
          document.getElementById("dimensionVerticalDisplayCM").textContent = `${heightCM}cm`;
          document.getElementById(
            "size-display"
          ).textContent = `${widthCM}cm x ${heightCM}cm / ${widthInch}in x ${heightInch}in`;
      }
    }
  }
  //preview functions end

  //helping functions start
  function validateWidth(widthInch) {
    const addToCartButton = document.getElementById("add-to-cart");
    const cartErrorMessage = document.getElementById("cart-error-message");

    if (widthInch > 96 && sizeOption == 'custom') {
      cartErrorMessage.classList.remove("hidden");
      addToCartButton.disabled = true;
      addToCartButton.classList.remove("bg-customBlue");
      addToCartButton.classList.add("bg-neutral-600");
      setTimeout(() => {
      }, 3000);
    } else {
      cartErrorMessage.classList.add("hidden");
      addToCartButton.disabled = false;
      addToCartButton.classList.remove("bg-neutral-600");
      addToCartButton.classList.add("bg-customBlue");
    }
  }

  function updatePrice(height, width) {
    var fontRatio = {
      Alexa: 1.65,
      Bayshore: 1.65,
      Dancer: 1.42,
      Gruenewald: 1.34,
      NewCursive: 1.56,
      Barcelony: 1.9,
      Vintage: 1.48,
      Amanda: 1.34,
      Budhayan: 1.67,
      Sebastian: 1.79,
      Signature: 1.33,
      Assalwa: 1.37,
      Hamilton: 1.67,
      Hesterica: 1.59,
      LoveNote: 1.74,
      Northwell: 1.59,
      Quinzey: 1.73,
      RedVelvet: 1.53,
      Rocket: 1.55,
      WildScript: 1.29,
      AvantGrade: 1.32,
      Bauhaus: 1.32,
      DOLCEVITA: 1,
      KIONA: 1,
      NixieOne: 1.43,
      Typewriter: 1.24,
      PaperDaisy: 1.31,
      Roboto: 1.41,
      BRAVE: 1.63,
      LOVELO: 1,
      Marquee: 1.09,
      NeonGlow: 1.47,
      NeonLite: 0.98,
      NEONTUBE: 1,
      Outline: 1.4,
      SciFi: 1,
    };
    var priceFactor = 2;
    var multiplyratio = 1;
    var manufacture_cost = 0;

    switch (sizeOption) {
      case 'small':
        height = 7;
        width = 37.14;
        break;
      case 'medium':
        height = 9.804
        width = 51.99;
        break;
      case 'large':
        height = 11.90
        width = 63.13;
        break;
      case 'extra large':
        height = 13.99;
        width = 74.27;
        break;
    }

    if (neonObject.color.name === "rgb") {
      priceFactor = 3.5;
    }
    multiplyratio = fontRatio[neonObject.font];
    if (multiplyratio !== undefined) {
      width = width * multiplyratio;
    }

    var sq = Math.sqrt(height * width);
    if (
      neonObject.font == "SciFi" ||
      neonObject.font == "Nevada" ||
      neonObject.font == "LoveNeon" ||
      neonObject.font == "Marquee" ||
      neonObject.font == "NeonGlow" ||
      neonObject.font == "Mayfair"
    ) {
      manufacture_cost = sq * 4.75 * 2;
    } else {
      manufacture_cost = sq * 4.75 * 1;
    }
    var conversion = (2.54 * 2.54 * 2.54) / 5000;
    var shipping_cost =
      (width + 2) * (height + 2) * 4 * conversion * 9.49 + 16.3;
    newPrice = (shipping_cost + manufacture_cost) * priceFactor;
    newPrice = newPrice.toFixed(0);
    var changeToTen = newPrice
      .toString()
      .charAt(newPrice.toString().length - 1);
    newPrice =
      parseInt(changeToTen) >= 5
        ? parseInt(newPrice) + parseInt(10 - parseInt(changeToTen))
        : parseInt(newPrice) - parseInt(changeToTen);
    newPrice = newPrice + neonObject.shipping;
    if (width == 0 || height == 0) {
      document.getElementById("price-display").textContent = "Price: $0";
    } else if (newPrice < 140) {
      document.getElementById("price-display").textContent = "Price: $140";
    } else {
      document.getElementById("price-display").textContent =
        "Price: $" + newPrice;
    }
  }

  function showPopup(value) {
    const popupImage = document.getElementById('popupImage');
    if (value === 'Shape') {
      popupImage.src = "https://cdn.shopify.com/s/files/1/0887/4931/0318/files/fHiOG0_c9kN-G7NoFGHBW.png?v=1734417992";
    }
    else if (value === 'Square') {
      popupImage.src = "https://cdn.shopify.com/s/files/1/0887/4931/0318/files/WHkoMU7r8tXohXOpAEzFv.png?v=1734417992";
    } else if (value === 'Letter') {
      popupImage.src = "https://cdn.shopify.com/s/files/1/0887/4931/0318/files/D8b3UhhiTNpCWch8-W7Je.png?v=1734417992";
    }
    const popup = document.getElementById('popup');
    popup.style.bottom = "10px";
    popup.classList.remove('hidden');
  }

  function openImage() {
    const popupImage = document.getElementById('popupImageFull');
    popupImage.src = document.getElementById('popupImage').src;

    const popupOverlay = document.getElementById('popupOverlay');
    popupOverlay.classList.remove('hidden');
  }

  function closePopup(value) {
    const popup = document.getElementById(value);
    popup.classList.add('hidden');
  }

  function populateFontSelector() {
    const fontSelector = document.getElementById("font-selector");
    availableFonts.forEach((font) => {
      const option = document.createElement("option");
      option.value = font.name;
      option.textContent = font.name;
      option.style = font.style;
      fontSelector.appendChild(option);
    });
  }

  function hexToRGBA(hex, alpha) {
    hex = hex.replace("#", "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  function getTextDimensions(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const width = context.measureText(text).width;
    const div = document.createElement("div");
    div.style.position = "absolute";
    div.style.whiteSpace = "nowrap";
    div.style.visibility = "hidden";
    div.style.font = font;
    div.textContent = text;
    document.body.appendChild(div);
    const height = div.offsetHeight;
    document.body.removeChild(div);
    return { width, height };
  }

  function initializeDraggable() {
    const parentContainer = document.querySelector('.parent-container');
    const draggableContainer = document.querySelector('.draggable-container');

    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;

    function startDragging(event) {
      isDragging = true;
      const clientX = event.clientX || event.touches[0].clientX;
      const clientY = event.clientY || event.touches[0].clientY;
      offsetX = clientX - draggableContainer.offsetLeft;
      offsetY = clientY - draggableContainer.offsetTop;
      event.preventDefault();
    }

    function drag(event) {
      if (!isDragging) return;
      const clientX = event.clientX || event.touches[0].clientX;
      const clientY = event.clientY || event.touches[0].clientY;

      let x = clientX - offsetX;
      let y = clientY - offsetY;
      const parentRect = parentContainer.getBoundingClientRect();
      const draggableRect = draggableContainer.getBoundingClientRect();

      if (x < 0) x = 0;
      if (y < 0) y = 0;
      if (x + draggableRect.width > parentRect.width) x = parentRect.width - draggableRect.width;
      if (y + draggableRect.height > parentRect.height) y = parentRect.height - draggableRect.height;

      draggableContainer.style.left = `${x}px`;
      draggableContainer.style.top = `${y}px`;
    }

    function stopDragging() {
      isDragging = false;
    }

    // Mouse event listeners
    draggableContainer.addEventListener('mousedown', startDragging);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDragging);

    // Touch event listeners
    draggableContainer.addEventListener('touchstart', startDragging, { passive: false });
    document.addEventListener('touchmove', drag, { passive: false });
    document.addEventListener('touchend', stopDragging);
  }
  //helping functions end


  document.addEventListener("DOMContentLoaded", () => {
    const fonts = [
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/AlexaNew.woff2?v=1761811714",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Northshore.woff2?v=1761811714",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/WildScript.woff2?v=1761811714",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/LoveNote.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Signature.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/LoveNeon.woff2?v=1761807818",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Melbourne.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Greenworld.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Bayview.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/NewCursive.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Typewriter.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/NeoTokyo.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Marquee.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Buttercup.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Chelsea.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/ClassicType.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Roboto-Regular.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Royalty.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Roboto-Medium.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Beachfront.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Austin.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Neontrace.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Amsterdam.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Vintage.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Freehand.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Neonscript.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Freespirit.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/NeonLite.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Outline.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Rocket.woff2?v=1761811145",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/NeonGlow_8169f7c0-5bc0-483d-8adb-e529316218c7.woff2?v=1761811714",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Amanda.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Monaco.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Barcelona.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Bauhaus.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/Waikiki.woff2?v=1761811144",
      "https://cdn.shopify.com/s/files/1/0626/5182/6311/files/SciFi.woff2?v=1761811144"
    ];

    Promise.all(
      fonts.map((url) => {
        const font = new FontFace("CustomFont", `url(${url})`);
        return font.load().then(() => {
          document.fonts.add(font);
        });
      })
    ).then(() => {
      console.log("All fonts are loaded.");
      updatePreview();
    }).catch((error) => {
      console.error("Error loading fonts:", error);
    });
  });

  document.addEventListener("DOMContentLoaded", populateFontSelector);
  document.addEventListener("DOMContentLoaded", updatePreview);
  window.addEventListener("load", updatePreview);
  window.addEventListener("resize", updatePreview);
  window.onload = initializeDraggable;